export default __webpack_public_path__ + "static/media/re.d674bc9a.jpg";